import React, {useState, useRef, useEffect} from 'react';
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import {useDispatch} from "react-redux";

import css from './SelectPaymentRecordStatusModal.module.css';
import {getOptionSelectPaymentStatus} from "../../../../helpers";
import {ordersService} from "../../../../services/orders-services";
import {ordersActions} from "../../../../store/slices/orders-slices";


const SelectPaymentRecordStatusModal = ({paymentStatus, orderId, paymentId}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const dropdownRef = useRef(null);

    const optionItems = getOptionSelectPaymentStatus(t);

    // Convert raw payment status to translated version
    const getTranslatedStatus = (rawStatus) => {
        switch(rawStatus) {
            case 'Completed':
                return t('completed');
            case 'Created':
                return t('created');
            case 'Rejected':
                return t('rejected');
            case 'Declined':
                return t('declined');
            case 'Other':
                return t('other');
            default:
                return rawStatus;
        }
    };

    const [selectedStatus, setSelectedStatus] = useState(getTranslatedStatus(paymentStatus));
    const [isOpenDropdown, setIsOpenDropdown] = useState(false);

    // Update selected status when paymentStatus prop changes
    useEffect(() => {
        setSelectedStatus(getTranslatedStatus(paymentStatus));
    }, [paymentStatus, t]);

    // Determine button class based on raw status value
    const getButtonClass = () => {
        switch(paymentStatus) {
            case 'Completed':
                return css.btnCompleted;
            case 'Created':
                return css.btnCreated;
            case 'Rejected':
            case 'Declined':
                return css.btnRejected;
            case 'Other':
            default:
                return css.btnOther;
        }
    };

    const handleSelect = async (status) => {
        try {
            const newStatus = status.forBack;
            
            const formatedData = {
                paymentStatus: newStatus,
            };

            // Wait for backend update to complete BEFORE updating UI
            await ordersService.updatePaymentStatus(orderId, paymentId, formatedData);
            
            // Small delay to ensure database transaction is fully committed
            await new Promise(resolve => setTimeout(resolve, 100));
            
            // Only update UI after successful backend update
            setSelectedStatus(status.name);
            dispatch(ordersActions.changeTrigger());
            setIsOpenDropdown(false);
        } catch (error) {
            console.error(t('modal-toast-fetch-error'), error);
            toast.error(t('modal-toast-fetch-error'));
        }
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpenDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    return (
        <div className={css.wrap} ref={dropdownRef} onClick={(e) => e.stopPropagation()}>
            <button
                className={`${css.btn} ${getButtonClass()}`}
                type="button"
                onClick={(e) => {
                    e.stopPropagation();
                    setIsOpenDropdown(prev => !prev);
                }}
            >
                {selectedStatus}
            </button>

            {isOpenDropdown && (
                <div className={css.dropdown}>
                    {optionItems.map(status => (
                        <div
                            key={status.name}
                            className={css.dropdownOption}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleSelect(status);
                            }}
                        >
                            <span>{status.name}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SelectPaymentRecordStatusModal;

